var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30.000000pt",
    height: "30.000000pt",
    viewBox: "0 0 30.000000 30.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,30.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169 250 c-24 -23 -30 -37 -27 -62 3 -32 2 -33 -30 -30 -25 3 -39 -3 -62 -27 -17 -16 -30 -39 -30 -50 0 -27 34 -61 61 -61 25 0 79 52 79 77 0 13 -8 8 -31 -20 -17 -20 -38 -37 -48 -37 -21 0 -41 19 -41 40 0 22 41 60 65 60 17 0 17 -1 0 -20 -10 -11 -15 -23 -11 -27 4 -4 32 18 63 50 32 31 54 59 50 63 -4 4 -16 -1 -27 -11 -19 -18 -20 -17 -20 2 0 22 39 63 61 63 20 0 39 -20 39 -41 0 -10 -17 -31 -37 -48 -28 -23 -33 -31 -20 -31 25 0 77 54 77 79 0 12 -9 30 -20 41 -28 28 -57 25 -91 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.47b788dc9edc6a2eb5bedcbf4f747e3e.svg";
export { ForwardRef as ReactComponent };